var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.12 0.559453L16 2.43945L8 10.4395L-3.49691e-07 2.43945L1.88 0.559454L8 6.66612L14.12 0.559453Z",
    fill: "#969FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGray);
export default __webpack_public_path__ + "static/media/arrow-down-gray.0b0f66b6955d0d28c11d782d49c8e827.svg";
export { ForwardRef as ReactComponent };